module.exports = __webpack_public_path__ + "img/call-center.d7004858.png";